import Property3GridContainer from "../../../components/property/grid/Property3Grid";

const Property3Grid = () => {
  return <Property3GridContainer />;
};

export default Property3Grid;
